<script setup lang="ts">
import DefaultLayout from '~/layouts/default.vue'

const filters = defineModel<PlannedDeliveryFilters>({
  required: true,
})

const tab = computed({
  get() {
    return STATUS_TO_TAB[filters.value?.status]
  },
  set(value: PlannedDeliveryTab) {
    filters.value = { ...filters.value, status: TAB_TO_STATUS[value] }
  },
})
</script>

<template>
  <DefaultLayout>
    <KernelStack gap="1">
      <h1>{{ $t('header.plannedDeliveries') }}</h1>

      <PlannedDeliveriesTabs v-model="tab" />

      <slot
        :model-value="filters"
        @update:model-value="filters = $event"
      />
    </KernelStack>
  </DefaultLayout>
</template>

<style scoped>
:deep(.page) {
  display: contents;

  > * {
    grid-column: main;
  }
}
</style>
